import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Header from "../components/layout/Header/Header.jsx";
import Footer from "../components/layout/Footer/Footer.jsx";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <main className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-20">
        <h1 className="text-6xl md:text-9xl font-bold text-gray-200 mb-4">
          404
        </h1>
        <h3 className="text-2xl md:text-4xl font-semibold mb-6">
          {t("notFound.title")}
        </h3>
        <p className="text-gray-600 mb-10 max-w-md">
          {t("notFound.description")}
        </p>
        <Link
          to="/"
          className="bg-black text-white px-8 py-3 rounded-full hover:bg-gray-800 transition-colors duration-300"
        >
          {t("notFound.backHome")}
        </Link>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
